// extracted by mini-css-extract-plugin
export var recentNews = "recentnews-module--recent-news--PB5tD";
export var recentNewsContent = "recentnews-module--recent-news-content--uypmA";
export var recentNewsHeader = "recentnews-module--recent-news-header--nEP+l";
export var recentNewsItem = "recentnews-module--recent-news-item--G72m0";